import {eTipoPermissao} from "@/enums/ePermissoes";

export default [
 {
  description: "Plano de Contas",
  path: "/prestacaocontas/pcoplanocontas",
  name: "pcoplanocontas",
  component: () => import("@/views/prestacaocontas/pcoplanocontas/Index.vue"),
  meta: {
   permissions: [eTipoPermissao.PLANOCONTASNOVO_MENU_2900400299],
  },
  goesToMenu: true,
 },
 {
  description: "Cadastro de Plano de Contas",
  path: "/prestacaocontas/pcoplanocontas/cadastro/:id?",
  parent: "pcoplanocontas",
  name: "pcoplanocontas_create",
  component: () => import("@/views/prestacaocontas/pcoplanocontas/InclusaoEdicao.vue"),
  meta: {
   permissions: [eTipoPermissao.PLANOCONTASNOVO_MENU_2900400299],
  },
  goesToMenu: true,
 },
]
